import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialShare2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 4.57h-1.53V6.1h-1.52V4.57h-1.52V3.05h1.52V1.52h-1.52V0h-1.53v6.1h-4.57v1.52h4.57v6.09h1.53v-1.52h1.52v-1.52h1.52V9.14h1.53V7.62H32V6.1h-1.52zm-3.05 12.19h1.52v12.19h-1.52Z\"/><path fill=\"currentColor\" d=\"M27.43 3.05h1.52v1.52h-1.52Zm-1.52 25.9h1.52v1.53h-1.52ZM3.05 30.48h22.86V32H3.05ZM16.76 7.62h3.05v1.52h-3.05Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v7.62h-1.53ZM3.05 3.05h15.24v1.52H3.05Zm-1.53 25.9h1.53v1.53H1.52Zm0-24.38h1.53V6.1H1.52ZM0 6.1h1.52v22.85H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialShare2
